export default "__VITE_ASSET__DkO7O8Pq__"